<template>
  <DataList
    title="Стадії воронки продажів"
    resource="crm-sales-funnel-stages"
    :columns="columns"
    :get-items-fn="getTypes"
  />
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as salesFunnelStagesApi from "../../backend/salesFunnelStagesApi.js";

export default {
  components: {
    DataList,
  },
  data: () => ({
    columns: [
      { title: "Найменування", name: "title" },
      { title: "Дата створення", name: "date" },
      { title: "Тип", name: "type" },
    ],
  }),
  methods: {
    async getTypes(...args) {
      const data = await salesFunnelStagesApi.getStages(args[0], args[1], args[2], args[3]);
      data.result = data.result.map(e=>{
        return {
          id: e.id,
          title: e.title,
          date: e.date,
          type: e.salesFunnelType ? e.salesFunnelType.title : "",
        };
      });

      return data;
    },
  },
};
</script>
